import { Organization, RealmA6bEnum, Role } from '@goldcast/api/backend';

import { State, GetIsPermissionAllowedParams } from './types';
const rolesRealm: Array<RealmA6bEnum> = ['studio_app', 'event_app', 'content_lab'];

const getters = {
  getIsPermissionAllowed:
    (state: State, getters, rootState, rootGetters) =>
    ({ permissionType, hasBasicWorkspacePermission = true }: GetIsPermissionAllowedParams) => {
      const isPermissionsEnabled: boolean = rootGetters['orgPricingConfig/getIsPermissionsEnabled'];

      if (isPermissionsEnabled) {
        // If permission list contains *:* then allow all permissions
        if (state.permissionConfig?.permission_list?.includes('*:*')) {
          return true;
        }

        // Check if all required permissions are included in the permission list
        return permissionType.every(permission => state.permissionConfig?.permission_list?.includes(permission));
      }

      const currentOrg: Organization = rootGetters['org/getCurrentOrg'];

      if (currentOrg?.is_workspace_enabled) {
        return hasBasicWorkspacePermission;
      }

      return true;
    },
  getAllRoles: (state: State) => {
    let roles: Array<Role> = [];
    rolesRealm.forEach(realm => {
      roles = [...roles, ...(state.rolesByRealm?.[realm] ?? [])];
    });

    return roles;
  }
};

export default getters;
